export default {
  breadcrumb: {
    catalog: 'Catalog',
  },
  by: 'by',
  preorderBadge: 'Pre-order',
  metaDescription: 'Buy {name} — instant key delivery at KeyzoStore.',
  price: {
    soldOut: 'Sold out',
  },
  unavailable: 'This listing is no longer available.',
  addToCart: {
    inCart: 'In cart · {qty}',
  },
  share: 'Share',
  notFound: {
    title: 'We could not find that game',
    body: 'The link may be old, or the listing was removed.',
    action: 'Browse the catalog',
  },
  chips: {
    countries: 'Available in {count} countries',
    metacritic: 'Metacritic {score}',
  },
  delivery: {
    label: 'Delivery',
    hint: 'Your key appears in your orders and inbox.',
  },
  stock: {
    label: 'Stock',
    keys: 'keys from live offers',
  },
  region: {
    label: 'Region',
  },
  gallery: {
    label: 'Screenshots',
    show: 'Open screenshot {n}',
    counter: '{current} / {total}',
  },
  description: {
    label: 'Description',
    showMore: 'Show more',
    showLess: 'Show less',
    noDescription: 'No description available for this title.',
  },
  details: {
    title: 'Details',
    developers: 'Developers',
    publishers: 'Publishers',
    releaseDate: 'Release date',
    languages: 'Languages',
    platform: 'Platform',
  },
  related: {
    title: 'You may also like',
    fallbackTitle: 'More from the catalog',
  },
  offers: {
    sectionTitle: 'Available from sellers',
    unknownSeller: 'Marketplace seller',
    qty: '{count} in stock',
    bestPriceBadge: 'Best price',
    soldOutBadge: 'Sold out',
    selectButton: 'Select',
    soldOutButton: 'Sold out',
  },
  wishlistAriaLabel: {
    add: 'Add to wishlist',
    remove: 'Remove from wishlist',
  },
  card: {
    wishlist: 'Save to wishlist',
    delivery: {
      instant: 'Instant',
      preorder: 'Pre-order',
      outOfStock: 'Out of stock',
    },
  },
};
